import PMBModalImagePreview from 'components/PMBModalImagePreview'
import SidebarDetails from 'components/SidebarDetails'
import { useState } from 'react'
import { Card, CardText } from 'reactstrap'
import { formatDatePMBV2 } from 'utils/formatDate'

const SidebarDetailEvent = ({ isOpen, toggle, detailRow, userId }) => {
  const [modalOpenImage, setModalOpenImage] = useState(false)
  const [images, setImages] = useState([])

  return (
    <>
      <PMBModalImagePreview
        isOpen={modalOpenImage}
        toggle={() => setModalOpenImage(!modalOpenImage)}
        images={images}
        isDownload
      />
      <SidebarDetails
        size="lg"
        open={isOpen}
        title="Detail Event"
        headerClassName="mb-1"
        contentClassName="pt-0"
        toggleSidebar={toggle}
      >
        <>
          <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Judul
              </CardText>
              <p className="m-0">{detailRow?.title ?? '-'}</p>
            </div>
          </Card>

          <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Kreator
              </CardText>
              <p className="m-0">{detailRow?.creatorName ?? '-'}</p>
              <p className="m-0">{detailRow?.institutionName ?? ''}</p>
            </div>
          </Card>

          <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Tanggal Event
              </CardText>
              <div>
                {detailRow?.eventDate || detailRow?.startDate
                  ? formatDatePMBV2(
                      detailRow?.eventDate || detailRow?.startDate,
                    )
                  : '-'}
              </div>
            </div>
          </Card>

          <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Tanggal Kedaluwarsa Event
              </CardText>
              <div>
                {detailRow?.expiryDate || detailRow?.endDate
                  ? formatDatePMBV2(detailRow?.expiryDate || detailRow?.endDate)
                  : '-'}
              </div>
            </div>
          </Card>

          {detailRow?.note && userId && (
            <Card body className="mb-3 mt-3 border-0 shadow-sm">
              <div>
                <CardText tag="h6" className="fw-semibold">
                  Catatan
                </CardText>
                <p className="m-0">{detailRow?.note ?? '-'}</p>
              </div>
            </Card>
          )}

          {detailRow?.description && !userId && (
            <Card body className="mb-3 mt-3 border-0 shadow-sm">
              <div>
                <CardText tag="h6" className="fw-semibold">
                  Deskripsi
                </CardText>
                <p className="m-0">{detailRow?.description ?? '-'}</p>
              </div>
            </Card>
          )}

          {/* <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Kedaluwarsa Sertifikasi
              </CardText>
              <p className="m-0">
                {formatDatePMBV2(detailRow?.certificateExpireDate) ?? '-'}
              </p>
            </div>
          </Card> */}
          <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Lokasi
              </CardText>
              <p className="m-0">{detailRow?.location ?? '-'}</p>
            </div>
          </Card>
          {/* <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Pemateri
              </CardText>
              <>
                <p className="m-0">{detailRow?.performeByUser ?? '-'}</p>
                <p className="m-0">{detailRow?.performeByUserEmail ?? '-'}</p>
              </>
            </div>
          </Card> */}
          <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Tipe
              </CardText>
              <p className="m-0">{detailRow?.eventTypeName ?? '-'}</p>
            </div>
          </Card>
          <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Kategori
              </CardText>
              <p className="m-0">{detailRow?.categoryName ?? '-'}</p>
            </div>
          </Card>
          {/* <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Event Partner
              </CardText>
              <p className="m-0">{detailRow?.partnerName ?? '-'}</p>
            </div>
          </Card> */}

          {/* <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Status
              </CardText>
              <p className="m-0">{detailRow?.status ?? '-'}</p>
            </div>
          </Card> */}
          <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Total Peserta
              </CardText>
              <p className="m-0">{detailRow?.totalParticipants ?? '-'}</p>
            </div>
          </Card>

          <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Lampiran
              </CardText>

              {(() => {
                let attachments = []

                try {
                  attachments = Array.isArray(detailRow?.attachments)
                    ? detailRow?.attachments
                    : JSON.parse(detailRow?.attachments || '[]')
                } catch {
                  attachments = []
                }

                return attachments?.length > 0 ? (
                  <PMBModalImagePreview
                    isModal={false}
                    images={attachments}
                    onClick={() => {
                      setModalOpenImage(true)
                      setImages(attachments)
                    }}
                  />
                ) : (
                  '-'
                )
              })()}
            </div>
          </Card>

          {/* <Card body className="mb-3 mt-3 border-0 shadow-sm">
            <div>
              <CardText tag="h6" className="fw-semibold">
                Terverifikasi
              </CardText>
              <p className="m-0">Oleh: {detailRow?.verifiedBy ?? '-'}</p>
              <p className="m-0">
                Institusi: {detailRow?.verifiedInstitution ?? '-'}
              </p>
            </div>
          </Card> */}
        </>
      </SidebarDetails>
    </>
  )
}

export default SidebarDetailEvent
